import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100%;
  padding: 24px;
  background-color: var(--neutral-theme);
`

export const Contend = styled.div`
  display: flex;
  flex: 1%;
  flex-direction: column;
  width: 100%;
`

export const ContainerButton = styled.div`
  padding: 16px 24px;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: var(--neutral-theme);
`
